<template>
  <ul :class="$style.component">
    <li v-for="(image, index) in item.images" :key="index" :class="$style.item">
      <div :class="imageClass(image)">
        <BaseImage :image="image" :lazy="true" />
        <div
          :class="$style.caption"
          v-if="image.description"
          v-html="image.description"
        ></div>
      </div>
    </li>
  </ul>
</template>

<script>
import BaseImage from '@/components/base-image'

export default {
  components: { BaseImage },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  methods: {
    imageClass(image) {
      return [
        this.$style.image,
        this.isPortrait(image) ? this.$style['is-portrait'] : ''
      ]
    },
    isPortrait(image) {
      return image.ratio < 1
    }
  }
}
</script>

<style lang="scss" module>
.component {
  &:not(:last-child) {
    margin: calc(var(--blank-line) * 2) 0;
  }

  @media (min-width: $large) {
    &:not(:last-child) {
      margin: calc(var(--blank-line) * 3) 0;
    }
  }
}

.item {
  margin-right: auto;
  margin-left: auto;
  max-width: 25em;

  &:not(:last-child) {
    margin-bottom: calc(var(--blank-line) * 2);
  }
}

.image {
  &.is-portrait {
    margin-right: auto;
    margin-left: auto;
    width: 80%;
  }

  @media (min-width: $small) {
    &.is-portrait {
      width: 60%;
    }
  }

  @media (min-width: $large) {
    &.is-portrait {
      width: 50%;
    }
  }
}

.caption {
  @extend %ff-sans;
  @extend %fs-xsmall;
  margin: var(--blank-line) auto 0;
  max-width: 30em;
  text-align: center;
}
</style>
